<template>
    <div class="header">
    <img class="logo" alt="Vue logo" src="@/assets/logo.jpg">
    <h1>
      Material Requirement Analysis
      <span v-if="displayDate" style="font-size:0.7em; color:#555; margin-left:16px;">
        Data last modified: {{ displayDate }}
      </span>
    </h1>
    <button class="logout-btn" @click="logout">Logout</button>
  </div>
  <nav class="navbar">
    <router-link to="/finished-goods-analysis" class="nav-link">Finished Goods Analysis</router-link>
    <router-link to="/component-analysis" class="nav-link">Component Analysis</router-link>
    <router-link to="/oa-registrar" class="nav-link">OA Registrar</router-link>
    <!-- <router-link to="/delivery-schedule" class="nav-link">Delivery Schedule</router-link> -->
    <router-link to="/purchase-req" class="nav-link">Purchase Requisition</router-link>
    <router-link to="/mach-req" class="nav-link">Machining Requisition</router-link>
    <router-link to="/fg-req" class="nav-link">FG Requisition</router-link>
    <router-link to="/bom" class="nav-link">BOM</router-link>
    <router-link to="/assembly-plan" class="nav-link">Assembly Plan</router-link>
  </nav>
  
  <div id="app">
  <router-view />
  </div>

</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted } from 'vue';

const router = useRouter();
const backendUrl = process.env.VUE_APP_BACKEND_URL;
const displayDate = ref('');

function logout() {
  localStorage.removeItem('mra_auth');
  router.replace('/login');
}

onMounted(async () => {
  try {
    const res = await fetch(`${backendUrl}/excel/last-modified`);
    const data = await res.json();
    console.log('Fetched data:', data);
    const last = data.lastModified || {};
    if (last.sharepointLastModified && last.cacheLastRefreshed) {
      const spDate = new Date(last.sharepointLastModified);
      const cacheDate = new Date(last.cacheLastRefreshed);
      displayDate.value = (spDate < cacheDate ? spDate : cacheDate).toLocaleString();
    } else {
      displayDate.value = 'Unavailable';
    }
  } catch (e) {
    displayDate.value = 'Unavailable';
  }
});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 98px;
}
.layout {
  display: flex;
  margin-top: 0px;
  font-size: 14px; /* Reduce base font size */
}
.navbar {
  background: #222;
  padding: 10px 20px;
  display: flex;
  gap: 20px;
  align-items: center;
  position: fixed;
  top: 48px;
  width: 100vw;
}
.nav-link {
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 4px;
  transition: background 0.2s;
}
.nav-link.router-link-exact-active,
.nav-link:hover {
  background: #007bff;
  color: #fff;
}
.header {
  background: #ffffff;
  color: #000000;
  padding: 6px 12px;
  height: 48px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  box-sizing: border-box;
  font-size: 16px; /* Header slightly larger */
}
.logo {
  height: 32px;
  width: auto;
  margin-right: 10px;
}

.logout-btn {
  margin-left: auto;
  margin-right: 16px;
  padding: 6px 16px;
  background: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-weight: bold;
  cursor: pointer;
  height: 32px;
}
.logout-btn:hover {
  background: #c0392b;
}
</style>